import { render, staticRenderFns } from "./userCardLogs.vue?vue&type=template&id=450fd219&scoped=true"
import script from "./userCardLogs.vue?vue&type=script&lang=ts"
export * from "./userCardLogs.vue?vue&type=script&lang=ts"
import style0 from "./userCardLogs.vue?vue&type=style&index=0&id=450fd219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450fd219",
  null
  
)

export default component.exports